import Legal, { LegalSections } from './Legal';

export default Legal;
export { LegalSections };
